/* @flow */

import popoverTextarea from '../utils/popover-textarea';

import { type Empresa } from '../empresa/types';

const popoverAtivar = (empresa: Empresa, button: HTMLElement) => popoverTextarea(button, {
    titulo: `Ativar ${empresa.fantasia}?`,
    texto: 'Motivo',
    sim: 'Ativar',
    nao: 'Cancelar',
    posicao: 'top',
});

const popoverDesativar = (empresa: Empresa, button: HTMLElement) => popoverTextarea(button, {
    titulo: `Desativar ${empresa.fantasia}?`,
    texto: 'Motivo',
    sim: 'Desativar',
    nao: 'Cancelar',
    posicao: 'top',
});

const popoverAtivacao = (empresa: Empresa, button: HTMLElement) => (
    empresa.ativo ? popoverDesativar(empresa, button) : popoverAtivar(empresa, button)
);

export default popoverAtivacao;
